/** 从 data-share-* 读出分享载荷。属性名稳定，方便服务端模板和别的项目复用。 */
import type { SharePayload } from './types.ts'

function clean(value: string | undefined): string {
  return (value || '').trim()
}

export function payloadFromElement(root: HTMLElement): SharePayload | null {
  const headline = clean(root.dataset.shareHeadline)
  const text = clean(root.dataset.shareText)
  if (!headline && !text) return null
  const secret = clean(root.dataset.shareSecret)
  const url = clean(root.dataset.shareUrl) || `${window.location.origin}${window.location.pathname}`
  return {
    modalTitle: clean(root.dataset.shareModalTitle) || '分享',
    headline: headline || Array.from(text).slice(0, 40).join(''),
    text,
    url,
    secret: secret || undefined,
    secretToggleLabel: clean(root.dataset.shareSecretLabel) || '附带隐藏内容',
    badge: clean(root.dataset.shareBadge) || undefined,
    imageUrl: clean(root.dataset.shareImage) || undefined,
    footer: clean(root.dataset.shareFooter) || undefined,
    seal: clean(root.dataset.shareSeal) || undefined,
    secretSeal: clean(root.dataset.shareSecretSeal) || undefined,
  }
}
